import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class AuthService {

	private authObj: any;

	onUserAttr = new Subject<boolean>();

	constructor() { }

	setAuth(auth: any) {
		this.authObj = auth;
	}

	getAuth() {
		return this.authObj;
	}

	onUserAttrStored(isStored: boolean) {
		console.log('stored');
		this.onUserAttr.next(isStored);
	}

}
